import angular from 'angular'
import statisticsDeductionCheck from './statisticsDeductionCheck'

export default angular
    .module('app.statisticsDeductionCheck', [])
    .directive('statisticsDeductionCheck', statisticsDeductionCheck)
    .name



// WEBPACK FOOTER //
// ./src/components/statisticsDeductionCheck/index.js